<template>
  <div>
    <Header></Header>
    <div class="background">
      <div class="course_system">
        <!-- 微导航 -->
        <div class="wnav">
          <span>课程体系</span> >
          <span>全部课程</span> >
          <span>课程详情</span> >
          <span class="gengduo">4小时讲完概率论与数理统计</span>
        </div>
        <div class="title">4小时讲完概率论与数理统计</div>
        <div class="body">
          <div class="left">
            <div class="cont">
              <div>本节课讲【AI软件】书法字体logo的概述表达－以“松鹤面馆”为例，课程目的：了解书法字体logo创作的基本步骤，清楚毛笔的应用，课程重点；毛笔创作的手法，字形结合创意的呈现，课程难点：手写字体的尝试，手写字体设计和书法的概念转换以及案例中字和形的版式。</div>
              <img src="../assets/img/0.jpg" alt />
              <div>本节课讲【AI软件】书法字体logo的概述表达－以“松鹤面馆”为例，课程目的：了解书法字体logo创作的基本步骤，清楚毛笔的应用，课程重点；毛笔创作的手法，字形结合创意的呈现，课程难点：手写字体的尝试，手写字体设计和书法的概念转换以及案例中字和形的版式。</div>
              <img src="../assets/img/0.jpg" alt />
              <div>本节课讲【AI软件】书法字体logo的概述表达－以“松鹤面馆”为例，课程目的：了解书法字体logo创作的基本步骤，清楚毛笔的应用，课程重点；毛笔创作的手法，字形结合创意的呈现，课程难点：手写字体的尝试，手写字体设计和书法的概念转换以及案例中字和形的版式。</div>
              <img src="../assets/img/0.jpg" alt />
            </div>
          </div>
         <div class="right">
            <div class="right-top">
              <div class="lecturer">
                <div class="js">课程讲师</div>
                <div class="name">
                  <img src="../assets/img/0.jpg" alt />
                  <div class="center">
                    <span class="center-name">李秋水</span>
                    <span class="center-c">国家一级讲师</span>
                  </div>
                  <span class="jiantou">
                    <img src="../assets/img/in.png" alt />
                  </span>
                </div>
              </div>
            </div>
            <el-collapse class="right-center" v-model="activeNames" @change="handleChange">
              <el-collapse-item name="1">
                <template slot="title">
                  <div class="Catalog">第一章：概率论</div>
                </template>
                <ul>
                  <li>
                    <span>1.事件的概率</span>
                    <span>34:00</span>
                  </li>
                  <li>
                    <span>1.事件的概率</span>
                    <span>34:00</span>
                  </li>
                  <li>
                    <span>1.事件的概率</span>
                    <span>34:00</span>
                  </li>
                  <li>
                    <span>1.事件的概率</span>
                    <span>34:00</span>
                  </li>
                  <li>
                    <span>1.事件的概率</span>
                    <span>34:00</span>
                  </li>
                </ul>
              </el-collapse-item>
              <el-collapse-item name="2">
                 <template slot="title">
                  <div class="Catalog">第二章：概率论</div>
                </template>
                <ul>
                  <li>
                    <span>1.事件的概率</span>
                    <span>34:00</span>
                  </li>
                  <li>
                    <span>1.事件的概率</span>
                    <span>34:00</span>
                  </li>
                  <li>
                    <span>1.事件的概率</span>
                    <span>34:00</span>
                  </li>
                  <li>
                    <span>1.事件的概率</span>
                    <span>34:00</span>
                  </li>
                  <li>
                    <span>1.事件的概率</span>
                    <span>34:00</span>
                  </li>
                </ul>
              </el-collapse-item>
             
            </el-collapse>
            <!-- 相关推荐 -->
            <div class="right-bottom">
              <div class="related">相关推荐</div>
              <div class="related-list">
                <img src="../assets/img/0.jpg" alt />
                <div>
                  <div class="name">课程名称课程名称课程名称课程名称</div>
                  <div class="lecturer1">讲师：李永乐</div>
                </div>
              </div>
              <div class="related-list">
                <img src="../assets/img/0.jpg" alt />
                <div>
                  <div class="name">课程名称课程名称课程名称课程名称</div>
                  <div class="lecturer1">讲师：李永乐</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./header";
import Footer from "./footer";
export default {
  name: "course_system",
  data() {
    return {};
  },
  methods: {},
  components: {
    Header,
    Footer
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 微导航 */
.background .course_system {
  width: 1200px;
  margin: 0 auto;
}
.wnav {
  height: 30px;
  line-height: 40px;
  font-size: 14px;
  margin-bottom: 10px;
}
.wnav span.gengduo {
  color: rgba(136, 136, 136, 1);
}
.course_system .title {
  width: 374px;
  height: 40px;
  font-size: 28px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin-bottom: 12px;
}
.course_system .body {
  display: flex;
  justify-content: space-between;
}
.course_system .body .left {
  width: 860px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
}
.course_system .body .left .cont {
  width: 820px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
  margin: 0 auto;
  margin-top: 18px;
}
.course_system .body .left .cont div {
  margin-bottom: 18px;
}
.course_system .body .left .cont img {
  width: 820px;
  height: 461px;
}
/* 右边上 */
.course_system .body .right {
  width: 324px;
  border-radius: 3px;
  border: 1px solid rgba(237, 237, 237, 1);
}
/* 右边上 */
.right .right-top {
  width: 324px;
  height: 146px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(237, 237, 237, 1);
  margin-bottom: 16px;
}
.right .right-top .lecturer {
  width: 280px;
  height: 100px;
  margin: 0 auto;
  position: relative;
  top: 50%; /*偏移*/
  transform: translateY(-50%);
}
.right .right-top .lecturer .js {
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 20px;
  border-left: 3px solid #1775ef;
  padding-left: 5px;
}
.right .right-top .lecturer .name {
  display: flex;
}
.right .right-top .lecturer .name .jiantou img {
  margin-left: 108px;
  margin-top: 18px;
  width: 10px;
  height: 10px;
}
.right .right-top .lecturer .name img {
  width: 54px;
  height: 54px;
  border-radius: 50%;
}
.right .right-top .lecturer .name .center {
  display: inline-flex;
  flex-direction: column;
}
.right .right-top .lecturer .name .center .center-name {
  font-size: 18px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 25px;
}
.right .right-top .lecturer .name .center .center-c {
  font-size: 14px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 36px;
}
/* 右边中 */
.right .right-center {
  width: 324px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  margin-bottom: 16px;
}
.right .right-center .Catalog {
  width: 284px;
  margin: 0 auto;
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-left: 20px;
}
.right .right-center ul {
  padding: 0;
}
.right .right-center ul li {
  height: 20px;
  width: 260px;
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin: 0 auto;
}
.right .right-center ul li:hover {
  background: rgba(23, 117, 239, 0.1);
}
/* 右边下 */
.right .right-bottom {
  width: 324px;
  height: auto;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(237, 237, 237, 1);
}
.right .right-bottom .related {
  width: 280px;
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  border-left: 3px solid #1775ef;
  padding-left: 5px;
  margin: 0 auto;
  margin-bottom: 16px;
  margin-top: 20px;
}
.right .right-bottom .related-list {
  display: flex;
  width: 280px;
  margin: 0 auto;
  margin-bottom: 16px;
}
.right .right-bottom .related-list img {
  width: 110px;
  height: 73px;
  border-radius: 6px;
}
.right .right-bottom .related-list .name {
  font-size: 16px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
  margin-bottom: 12px;
}
.right .right-bottom .related-list .lecturer1 {
  font-size: 12px;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/course_system1.vue